import React from 'react';
import { useReactiveVar } from '@apollo/client';
import { Navigate } from 'react-router-dom';
import { userInfo } from '../../../apollo/cache';
import SUPPLEMENTAL_ROLE from '../../../constants/supplemental-Roles';
import {
  VIP_PORTAL_ADMIN,
  ORG_COORDINATOR,
  ORG_UNIT_COORDINATOR,
  ORG_UNIT_SPONSOR,
  ORG_SPONSOR
} from '../../../constants/system-roles';
import { useIsUserActingAsATMStore } from '../../calendar/CalendarStore';

const CUSTOMER_SYSTEM_ROLES = [
  ORG_SPONSOR,
  ORG_COORDINATOR,
  ORG_UNIT_SPONSOR,
  ORG_UNIT_COORDINATOR
];

/**
 * @typedef {object} AtmEditEventPageRedirectorProps
 * @property {Object} [data]
 */

/**
 * @param {AtmEditEventPageRedirectorProps} props
 */
const AtmEditEventPageRedirector = props => {
  const { data } = props;
  const { eventId } = data;

  const currentUserInfo = useReactiveVar(userInfo);
  const setIsUserActingAsATM = useIsUserActingAsATMStore.getState().setIsUserActingAsATM;

  const isCustomerAsATM = isUserCustomerActingAsATM(
    currentUserInfo.SystemRole.Id,
    currentUserInfo.SupplementalRole?.Id
  );

  setIsUserActingAsATM(currentUserInfo.SystemRole.Id === VIP_PORTAL_ADMIN ? true : null);

  const state = isCustomerAsATM ? { selectedAtmUser: currentUserInfo.Id } : null;

  return <Navigate to={`/calendar/edit-event/${eventId}`} state={state} />;
};

const isUserCustomerActingAsATM = (systemRoleId, supplementalRoleId) =>
  CUSTOMER_SYSTEM_ROLES.includes(systemRoleId) && supplementalRoleId === SUPPLEMENTAL_ROLE.ATM;

export default AtmEditEventPageRedirector;
